import ScreenWrapper from "@/components/ScreenWrapper"
import LearningPathSidebar from "@/pages/leerlijnen/detail/LearningPathSidebar"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { DetailSidebar, LayoutWithSidebar } from "toptaal-shared"

export const Route = createFileRoute("/beheer/leerlijnen/$learningPathId")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "curriculum"),
})

function RouteComponent() {
  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={
          <DetailSidebar
            goBackLabel="Leerlijnen"
            goBackRoute="/beheer/leerlijnen"
          >
            <LearningPathSidebar />
          </DetailSidebar>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
